import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import applicationNotificationsReducer from './slices/applicationNotifications';
import applicationReducer from './slices/applicationSlice';
import authReducer from './slices/authSlice';
import builderStoreReducer from './slices/builderStoreSlice';
import conditionalLogicReducer from './slices/conditionalLogicSlice';
import propertiesReducer from './slices/propertiesSlice';
import unsavedFieldReducer from './slices/unsavedFieldSlice';
import userReducer from './slices/userSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  application: applicationReducer,
  applicationNotifications: applicationNotificationsReducer,
  builderStore: builderStoreReducer,
  properties: propertiesReducer,
  user: userReducer,
  unsavedField: unsavedFieldReducer,
  conditionalLogic: conditionalLogicReducer,
});

export const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['application', 'builderStore'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
